import { MONTHS } from '../../suivi/constants/PiezometerSuiviConstants'
import { maxBy, meanBy, minBy, round, sumBy, isUndefined, isNil } from 'lodash'

export default class DtoMonthValues {
    constructor(day, arrayValues) {
        this.day = day
        MONTHS.map((month, index) => {
            this[month] = arrayValues[index]
        })
        const dataWithValues = arrayValues.filter(data => !isUndefined(data.value) && data.value !== null)
        const min = minBy(dataWithValues, 'value')
        const mean = dataWithValues.length > 0 ? meanBy(dataWithValues, 'value') : null
        const max = maxBy(dataWithValues, 'value')
        const sum = dataWithValues.length > 0 ? sumBy(dataWithValues, 'value') : null

        this.min = { value: min ? min.value : null, color: 'orange' }
        this.mean = { value: !isNil(mean) ? round(mean, 2) : null, color: 'orange' }
        this.max = { value: max ? max.value : null, color: 'orange' }
        this.sum = { value: !isNil(sum) ? round(sum, 2) : null, color: 'orange' }
        this.headers = ['day'].concat(MONTHS).concat(['min', 'mean', 'max', 'sum'])
    }
}
